import { useMediaQuery } from 'react-responsive'
import { screens } from '@unowmooc/themes'

const useIsMobile = () =>
  useMediaQuery({
    query: `(max-width: ${screens.smMax})`,
  })

export default useIsMobile
